export default __webpack_public_path__ + "media/images/logo-3794f5e7d333a4e843b581f0754b2c0e.svg";